// @flow
import React, { useEffect } from 'react';
import { useLogin } from 'react-admin';

type UserFederatedType = {
  location: {
    search: Object
  }
};

const UserFederated = ({ location }: UserFederatedType) => {
  const login = useLogin();

  useEffect(() => {
    const code = new URLSearchParams(location.search).get('code');
    const userpoolID = new URLSearchParams(location.search).get('state');
    login({ auth_code: code, userpool_id: userpoolID})
      .then(() => {})
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <center> Redirecting...... </center>;
};

export default UserFederated;
